export default "__VITE_ASSET__BfWE19jP__"